export class PpcOrdonnanceInformationsForm {
  assureNomComplet?: string;
  assureRegime?: string;
  assureCaisse: string;
  ald: boolean;
  prescriptionDuree: string;
  appareilPpcType: string;
  pression: string;
  interfaceType: string;
  modeleMarqueEtType?: string;

  constructor(
    assureNomComplet: string | undefined,
    assureRegime: string | undefined,
    assureCaisse: string,
    ald: boolean,
    prescriptionDuree: string,
    appareilPpcType: string,
    pression: string,
    interfaceType: string,
    modeleMarqueEtType?: string,
  ) {
    this.assureNomComplet = assureNomComplet;
    this.assureRegime = assureRegime;
    this.assureCaisse = assureCaisse;
    this.ald = ald;
    this.prescriptionDuree = prescriptionDuree;
    this.appareilPpcType = appareilPpcType;
    this.pression = pression;
    this.interfaceType = interfaceType;
    this.modeleMarqueEtType = modeleMarqueEtType;
  }

  toAPI(): PpcOrdonnanceInformationsFormAPI {
    return {
      assure_nom_complet: this.assureNomComplet,
      assure_regime: this.assureRegime,
      assure_caisse: this.assureCaisse,
      ald: this.ald,
      prescription_duree: this.prescriptionDuree,
      appareil_ppc_type: this.appareilPpcType,
      pression: this.pression,
      interface_type: this.interfaceType,
      modele_marque_et_type: this.modeleMarqueEtType,
    };
  }
}

export type PpcOrdonnanceInformationsFormAPI = {
  assure_nom_complet?: string;
  assure_regime?: string;
  assure_caisse: string;
  ald: boolean;
  prescription_duree: string;
  appareil_ppc_type: string;
  pression: string;
  interface_type: string;
  modele_marque_et_type?: string;
};
